"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionText = exports.Header = exports.StateBlockButton = exports.IconWrapper = exports.Wrapper = void 0;
const button_1 = require("@pulse-web-ui/button");
const theme_1 = require("@pulse-web-ui/theme");
exports.Wrapper = theme_1.styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
exports.IconWrapper = theme_1.styled.div `
  margin-bottom: 12px;
`;
exports.StateBlockButton = (0, theme_1.styled)(button_1.Button) `
  width: 100%;
  max-width: 328px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom !== null && $marginBottom !== void 0 ? $marginBottom : 0}px;
`;
exports.Header = theme_1.styled.h1 `
  ${theme_1.typography.medium24};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-top: 0;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;
  text-align: center;
`;
exports.DescriptionText = theme_1.styled.p `
  ${theme_1.typography.regular16}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 0;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;
  text-align: center;
`;
